import type { SymbolLayer } from 'react-map-gl';

const MarkerSymbolLayer: SymbolLayer = {
  id: "marker-symbol-layer",
  type: "symbol",
  layout: {
    "text-field": ["get", "count"],
    "text-size": 12
  }
}

export { MarkerSymbolLayer }
